import { convertDateString } from "../../utils/convertDateString";

const getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
  };

export const sanitizeForCsv = (row, colsToExport) => {
    const sanitized = {};

    console.log("ROOW", row)
    colsToExport.forEach((key) => {
        const value = getNestedValue(row, key);
        console.log(key, value, row)

        if (Array.isArray(value)) {
            sanitized[key] = value.join(', ');
        } else if (typeof value === 'object' && value !== null) {
            sanitized[key] = JSON.stringify(value);
        } else {
            sanitized[key] = value;
        }
    });

    return sanitized;
};

